import { theme } from '../theme.js';
import { Icon } from './Icon.js';

/**
 * New sort orders after moving list[index] one step up (-1) or down (+1).
 * Renumbers the whole list 0..n-1 (old orders may repeat) and returns only
 * the rows whose number changed.
 */
export function reorder<T extends { id: string; sortOrder?: number | null }>(
  list: T[], index: number, dir: -1 | 1,
): { id: string; sortOrder: number }[] {
  const to = index + dir;
  if (to < 0 || to >= list.length) return [];
  const next = [...list];
  [next[index], next[to]] = [next[to]!, next[index]!];
  return next
    .map((row, i) => ({ id: row.id, sortOrder: i, was: row.sortOrder }))
    .filter((r) => r.was !== r.sortOrder)
    .map(({ id, sortOrder }) => ({ id, sortOrder }));
}

/** Small ▲▼ pair for admin lists; clicks don't reach the row underneath. */
export function MoveButtons({ onUp, onDown, disabled }: {
  onUp?: () => void; onDown?: () => void; disabled?: boolean;
}) {
  const btn = (label: string, rotate: boolean, fn?: () => void) => (
    <button
      type="button"
      aria-label={label} title={label}
      disabled={disabled || !fn}
      onClick={(e) => { e.stopPropagation(); fn?.(); }}
      style={{
        width: 26, height: 22, padding: 0, border: `1px solid ${theme.border}`,
        background: theme.surface2, color: theme.textDim, borderRadius: 6,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: fn && !disabled ? 'pointer' : 'default', opacity: fn ? 1 : 0.35,
      }}
    >
      <Icon name="chevronD" size={13} style={rotate ? { transform: 'rotate(180deg)' } : undefined} />
    </button>
  );
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, flexShrink: 0 }}>
      {btn('Move up', true, onUp)}
      {btn('Move down', false, onDown)}
    </div>
  );
}
